import React from 'react'
import {Link} from 'react-router-dom'

const NotFound = () => (
  <div className="app blank sidebar-opened">
    <article className="content">
      <div className="error-card global">
        <div className="error-title-block">
          <h1 className="error-title">404</h1>
          <h2 className="error-sub-title"> Sorry, page not found </h2>
        </div>
        <div className="text-center mt-4">
          <Link className="btn btn-primary" to='/'>
            <i className="fa fa-angle-left"></i> Back to Dashboard
          </Link>
        </div>
      </div>
    </article>
  </div>
)

export default NotFound


// WEBPACK FOOTER //
// ./src/Pages/NotFound.js